export const SET_FLASH_MESSAGE = 'SET_FLASH_MESSAGE';
export const HIDE_FLASH_MESSAGE = 'HIDE_FLASH_MESSAGE';
export const SET_CURRENT_FLASH_MESSAGE = 'SET_CURRENT_FLASH_MESSAGE';

function generateId() {
  return new Date().valueOf().toString() + Math.floor((Math.random() * 10) + 1);
}

export function setMessage(text, sticky = false) {
  return {
    type: SET_FLASH_MESSAGE,
    id: generateId(),
    sticky,
    text,
  };
}

export function setSuccessMessage(text, sticky = false) {
  return {
    type: SET_FLASH_MESSAGE,
    id: generateId(),
    level: 'success',
    sticky,
    text,
  };
}

export function setErrorMessage(text, sticky = false) {
  return {
    type: SET_FLASH_MESSAGE,
    id: generateId(),
    level: 'error',
    sticky,
    text,
  };
}

export function hideFlashMessage(id) {
  return {
    type: HIDE_FLASH_MESSAGE,
    id,
  };
}
